import { render, staticRenderFns } from "./EditRatificacionesDigital.vue?vue&type=template&id=41cbbbc4"
import script from "./EditRatificacionesDigital.vue?vue&type=script&lang=js"
export * from "./EditRatificacionesDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41cbbbc4')) {
      api.createRecord('41cbbbc4', component.options)
    } else {
      api.reload('41cbbbc4', component.options)
    }
    module.hot.accept("./EditRatificacionesDigital.vue?vue&type=template&id=41cbbbc4", function () {
      api.rerender('41cbbbc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/tasks/EditRatificacionesDigital.vue"
export default component.exports